
// FOTA polling logic extracted from MeterDetails.js
// Usage: startPollingFotaStatus({ dispatch, Gateway_ID, header, setPollingMessage, setIsPolling, pollingIntervalRef, toast })
export function startPollingFotaStatus({ dispatch, Gateway_ID, header, setPollingMessage, setIsPolling, pollingIntervalRef, toast }) {
	if (pollingIntervalRef.current) return; // already polling
	setIsPolling(true);
	const options = {
		position: "top-right",
		autoClose: 3000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: false,
		draggable: true,
		theme: "colored",
	};

	pollingIntervalRef.current = setInterval(async () => {
		const res = await dispatch(
			// pollFotaStatus must be imported in the file using this function
			window.pollFotaStatusFn({ gatewayId: Gateway_ID, header })
		);
		console.log('FOTA polling response:', res);
		if (res?.payload) {
			setPollingMessage(res.payload.message || res.payload.data?.message);
			console.log('FOTA:', res.payload.message);
			console.log('----------------------', res.payload.message || res.payload.data?.message);

			if (res.payload.success === false || res.payload.data?.status === "failed" || res.payload.data?.status === "success") {
				clearInterval(pollingIntervalRef.current);
				pollingIntervalRef.current = null;
				setIsPolling(false);
				setPollingMessage("Getting the FOTA status..."); // clear message after polling stops
			}

			if (res.payload.data?.status === "success") {
				toast.success(res.payload.data?.message, options);
				setIsPolling(false);
			}     
			else if (res.payload.data?.error === "v_fail") {
				toast.error(res.payload.data?.message, options);
				setIsPolling(false);
			} else if (res.payload.data?.error === "network") {
				toast.error(res.payload.data?.message, options);
				setIsPolling(false);
			}
			else if (res.payload.success === false) {
				toast.error(res.payload.message || "FOTA status retrieval failed", options);
				setIsPolling(false);
			}
		}
	}, 2000);
}
